import { type AdSlotType } from '../config/ads'
import { STAMINA_DAILY_BONUS } from '../config/stamina'
import { t, tx } from '../i18n/translations'

export interface AdRewardDisclosure {
  title: string
  requirement: string
  reward: string
  incompleteNote: string
}

export function getAdRewardDisclosure(slot: AdSlotType): AdRewardDisclosure {
  return {
    title: slot === 'stamina' ? t('recoverFullAd') : t('dailyBonusAd'),
    requirement: t('adRewardRequirement'),
    reward:
      slot === 'stamina'
        ? t('adRewardStaminaDetail')
        : tx('adRewardDailyBonusDetail', { amount: STAMINA_DAILY_BONUS }),
    incompleteNote: t('adRewardIncompleteNote'),
  }
}

export function getAdRewardConfirmMessage(slot: AdSlotType): string {
  const disclosure = getAdRewardDisclosure(slot)
  return [
    disclosure.title,
    disclosure.requirement,
    disclosure.reward,
    disclosure.incompleteNote,
  ].join('\n')
}
